import { render, staticRenderFns } from "./ClientNotificationList.vue?vue&type=template&id=1d6fe777&scoped=true&"
import script from "./ClientNotificationList.vue?vue&type=script&lang=js&"
export * from "./ClientNotificationList.vue?vue&type=script&lang=js&"
import style0 from "./ClientNotificationList.vue?vue&type=style&index=0&id=1d6fe777&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6fe777",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VChip,VIcon,VSelect})
